

























































import { CanalVendaMarketplace, CanalVendaMarketplaceProduto } from '@/models'
import { maiorQueZero, obrigatorio } from '@/shareds/regras-de-form'
import { Vue, Component, Ref } from 'vue-property-decorator'
import SeletorDeCanalDeVendaMarketplace from './SeletorDeCanalDeVendaMarketplace.vue'

@Component({
	components: {
		SeletorDeCanalDeVendaMarketplace,
	},
})
export default class DialogoDeCanalDeVendaMarketplace extends Vue {
	@Ref() seletorDeCanal!: SeletorDeCanalDeVendaMarketplace
	@Ref() formulario!: HTMLFormElement
	canalVendaProduto: CanalVendaMarketplaceProduto | null = null
	mostra = false
	editando = false

	obrigatorio = obrigatorio
	maiorQueZero = maiorQueZero

	isMercadoLivre(canalVendaProduto: CanalVendaMarketplaceProduto) {
		return canalVendaProduto.canal && canalVendaProduto.canal.codigo === '7'
	}

	mostrar(canalVendaProduto: CanalVendaMarketplaceProduto | null, canaisJaCadastrados: CanalVendaMarketplace[], precoDeTabela: number) {
		this.mostra = true

		if (canalVendaProduto) {
			this.editando = true
			this.canalVendaProduto = canalVendaProduto
			if (this.seletorDeCanal) {
				this.seletorDeCanal.canaisJaCadastrados = []
			}
		} else {
			this.editando = false
			this.canalVendaProduto = {
				id: '',
				canal: null,
				preco: precoDeTabela,
				tipoAnuncio: null,
			}
			setTimeout(() => {
				if (this.seletorDeCanal) {
					this.seletorDeCanal.canaisJaCadastrados = canaisJaCadastrados
				}
			}, 10)
		}		
	}

	confirmar() {
		if (!this.formulario.validate()) return
		this.$emit('atualizarCanaisVenda', this.canalVendaProduto)
		this.fecharDialogo()
	}

	salvar() {
		if (!this.formulario.validate()) return
		this.$emit('salvarCanalEditado', this.canalVendaProduto)
		this.fecharDialogo()
	}

	fecharDialogo() {
		this.editando = false
		this.mostra = false
		this.canalVendaProduto = null
	}
}

